import { GraphQLAPIPlaygroundIcon } from "@gadgetinc/widgets/src/icons/GraphQLAPIPlaygroundIcon";
import { JavaScriptIcon } from "@gadgetinc/widgets/src/icons/JavaScriptIcon";
import { PreactIcon } from "@gadgetinc/widgets/src/icons/PreactIcon";
import { ReactIcon } from "@gadgetinc/widgets/src/icons/ReactIcon";
import { TypeScriptIcon } from "@gadgetinc/widgets/src/icons/TypeScriptIcon";
import { useStyletron } from "baseui";
import React from "react";

export const languageLabel = (language: string) => {
  const key = language.toLowerCase();

  switch (key) {
    case "js":
    case "javascript": {
      return "JavaScript";
    }
    case "ts":
    case "typescript": {
      return "TypeScript";
    }
    case "jsx":
    case "react": {
      return "React";
    }
    case "tsx": {
      return "React (TypeScript)";
    }
    case "preact": {
      return "Preact";
    }
    case "graphql": {
      return "GraphQL";
    }
    case "shell":
    case "shell-session": {
      return "Shell";
    }
    default: {
      return language;
    }
  }
};

export const LanguageIcon = (props: { language: string }) => {
  if (props.language.toLowerCase() === "javascript" || props.language === "js") {
    return <JavaScriptIcon />;
  } else if (props.language.toLowerCase() === "typescript" || props.language === "ts") {
    return <TypeScriptIcon />;
  } else if (props.language.toLowerCase() === "react" || props.language === "tsx" || props.language === "jsx") {
    return <ReactIcon />;
  } else if (props.language === "graphql") {
    return <GraphQLAPIPlaygroundIcon />;
  } else if (props.language === "preact") {
    return <PreactIcon />;
  } else {
    return null;
  }
};

export const LanguageIndicator = (props: {
  children: React.ReactNode;
  color: string;
  onClick?: () => void;
  $style?: React.CSSProperties;
}) => {
  const [css, $theme] = useStyletron();

  return (
    <div
      className={css({
        ...$theme.typography.MonoLabelXSmall,
        color: props.color,
        cursor: "pointer",
        ...props.$style,
      })}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
};
